import { BaseQueryFn, EndpointBuilder } from '@reduxjs/toolkit/query';
import { WebsiteDto } from '../types/dtos';
import { APP_ENDPOINTS } from 'app/endpoints';

export default (builder: EndpointBuilder<BaseQueryFn, string, string>) =>
    builder.mutation<void, WebsiteDto>({
        query: (payload) => ({
            url: APP_ENDPOINTS.WEBSITES,
            method: 'POST',
            body: payload,
        }),
        invalidatesTags: [
            { type: 'websites-with-join', id: 'GET-JOIN' },
            { type: 'websites', id: 'GET' },
        ],
    });
